@if (edit) {
  <div class="edit">
    <h3 translate>Tooling</h3>
    @if (toolingSearchService?.firstSelectedResult$ | async; as tooling) {
      <div class="tooling-info">
        <div class="tooling-info-row">
          <div class="row-label" translate>Tooling</div>
          <div class="row-value">{{ tooling.name }}</div>
        </div>
        <div class="tooling-info-row">
          <div class="row-label" translate>Inventory Number</div>
          <div class="row-value">{{ tooling.inventoryNumber }}</div>
        </div>
        <div class="tooling-info-row">
          <div class="row-label" translate>Machine(s)</div>
          <div class="row-value">{{ tooling.machines }}</div>
        </div>
        <div class="tooling-info-row">
          <div class="row-label" translate>Tooling for rotor(s)</div>
          <div class="row-value">{{ tooling.toolingForRotor }}</div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="grid">
    <div class="grid-header">
      <h4>{{ 'VALUE Toolings' | translate: { value: toolingSearchService?.state.total } }}</h4>
    </div>
    @if (toolingSearchService) {
      <rotec-default-grid-v2
        [height]="height"
        [columns]="toolingSearchService?.columns"
        [data]="toolingSearchService?.state$ | async"
        [darkMode]="true"
        [menuButton]="false"
        [selectConfig]="selectConfig"
        [filterButton]="false"
        [selectedResults]="toolingSearchService?.selectedIds$ | async"
        (stateChange)="toolingSearchService?.search($event)"
        (selectedResultsChange)="setSelectedToolingIds($event)"
        (fulltextSearchChanged)="toolingSearchService?.search({ fulltext: $event })"
      >
        <ng-template rotecGridCellV2="name" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.name }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="inventoryNumber" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.inventoryNumber }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="machines" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.machines }}</p>
        </ng-template>
        <ng-template rotecGridCellV2="toolingForRotor" let-dataItem="dataItem">
          <p class="grid-text-cell">{{ dataItem.toolingForRotor }}</p>
        </ng-template>
      </rotec-default-grid-v2>
    }
  </div>
}
